/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Wallet balance summary
 * @export
 * @interface WalletSummaryResponse
 */
export interface WalletSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof WalletSummaryResponse
     */
    balance: number;
}

/**
 * Check if a given object implements the WalletSummaryResponse interface.
 */
export function instanceOfWalletSummaryResponse(value: object): value is WalletSummaryResponse {
    if (!('balance' in value) || value['balance'] === undefined) return false;
    return true;
}

export function WalletSummaryResponseFromJSON(json: any): WalletSummaryResponse {
    return WalletSummaryResponseFromJSONTyped(json, false);
}

export function WalletSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WalletSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'],
    };
}

export function WalletSummaryResponseToJSON(json: any): WalletSummaryResponse {
    return WalletSummaryResponseToJSONTyped(json, false);
}

export function WalletSummaryResponseToJSONTyped(value?: WalletSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance': value['balance'],
    };
}

